//teamAffiliation:
// 1 : Norlab
// 2 : ASRL
export const teamMembers = [
  {
    name: 'Matěj Boxan',
    imageSrc: `assets/team_img/m_boxan.webp`,
    link: 'https://norlab.ulaval.ca/people/m_boxan/',
    teamAffiliation: 1,
  },
  {
    name: 'Gabriel Jeanson',
    imageSrc: `assets/team_img/g_jeanson_avatar.webp`,
    link: 'https://www.linkedin.com/in/gabriel-jeanson/',
    teamAffiliation: 1,
  },
  {
    name: 'Alexander Krawciw',
    imageSrc: `assets/team_img/alec.webp`,
    link: 'https://a-krawciw.github.io/#about',
    teamAffiliation: 2,
  },
  {
    name: 'Effie Daum',
    imageSrc: `assets/team_img/e_daum_avatar.webp`,
    link: 'https://norlab.ulaval.ca/people/e_daum/',
    teamAffiliation: 1,
  },
  {
    name: 'Xinyuan Qiao',
    link: 'https://www.linkedin.com/in/xinyuan-sam-qiao-8b15ba17a/',
    imageSrc: `assets/team_img/sam.webp`,
    teamAffiliation: 2,
  },
  {
    name: 'Sven Lilge',
    imageSrc: `assets/team_img/banner.webp`,
    link: 'https://svenlilge.github.io',
    teamAffiliation: 2,
  },
  {
    name: 'Timothy D. Barfoot',
    imageSrc: `assets/team_img/tdb_lelr.webp`,
    link: 'http://asrl.utias.utoronto.ca/~tdb/',
    teamAffiliation: 2,
  },
  {
    name: 'François Pomerleau',
    imageSrc: `assets/team_img/f_pomerleau.webp`,
    link: 'https://norlab.ulaval.ca/people/f_pomerleau/',
    teamAffiliation: 1,
  },
];
